import { api } from "../lib/api";
import { warm } from "../lib/kept";

/** Load the rail ahead of a tap on the tab. */
export function prefetchTalk(): void {
  warm("talk:rail", () => api.talk.rail());
}
